export default function Switch() {
  return {}
}
